import Vue from 'vue';
import { prefix_m } from 'src/constant.js';
import Component from 'vue-class-component';

//для Bootstrap
import datePicker from 'vue-bootstrap-datetimepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

Vue.use(datePicker);

//модальное окно
import TimeTracking from 'src/TimeTrackingModal/TimeTrackingContainer.js';
import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })

@Component
export default class Report extends Vue {
    
    constructor() {
        super();
        this.container = null;
        this.projectDescription = {
            id: "",
            jira_id: "",
            date: "", 
            title: "",
            is_inside: ""
        };
        this.date = "",
        this.month = "",
        this.year = ""
    }
    created(){
        this.container = this.$attrs.container;
    }
    mounted(){
        document.getElementById('datepicker').onblur = (e)=>{this.handleChangeCalendar(e)};
    }
    handleChangeCalendar(e){
        this.$data.date = e.target.value;
        this.container.setDate(e.target.value);
    }
    handleClick(e, side){
        if(side=='left'){
            this.container.items = this.container.setMonthDesc();
        }
        else if(side=='right'){
            this.container.items = this.container.setMonthAsc();
        }
    }
    handleClickModal(e, project){
        this.$modal.show('time-tracking');
    } 
    handleClickCellModalOpen(e, id, jira_id, title, day, is_inside){
        this.projectDescription.id = id;
        this.projectDescription.jira_id = jira_id;
        this.projectDescription.title = title;
        this.projectDescription.day = day;
        this.projectDescription.is_inside = is_inside;
    }
    render (h) {

        return(
            <div>
                <link href={/*prefix_m+*/"/assets/font/open-iconic/font/css/open-iconic.css"} rel="stylesheet"/>

                <nav class="navbar navbar-inverse bg-inverse">
                    <div>
                        <div class="navbar-brand" href="" style="outline: 0;">
                        <router-link to="/report" ><span class = "navbar-brand">Отчет о списаниях</span></router-link> </div>
                        <div class="navbar-brand" href="" style="outline: 0;">
                            <router-link to="/view_emp" >
                                <span class = "navbar-brand">Информация о сотрудниках </span>
                            </router-link>  
                        </div>
                    </div>
                    <div class="navbar-toggler-right">
                        <div class="navbar-brand align-top" style="font-size: 11pt; display: inline-block" href="">{this.container.getFullName()}</div>
                        <router-link to="/logout"> 
                            <span 
                                class="oi align-middle align-text-bottom exit mr-3" style="font-size: 23pt;  display: inline-block" data-glyph="account-logout" 
                            ></span>
                        </router-link>  
                    </div>
                </nav>
                <div style="position: relative" class="pl-5 my-3 row">
                    <date-picker class="calendar"
                        config={
                            {
                                //minDate: '2011-01', 
                                format: 'MM-YYYY', 
                                // https://github.com/moment/moment/tree/develop/locale
                                locale: 'ru'//,
                                //debug: true
                            }}
                        value={this.container.items}
                        id="datepicker"
                    ></date-picker>
                    <label class="col-md col-form-label text-danger">{this.container.getDebts()}</label>
                 </div>

                <modal style="overflow-y: scroll; height=625" name="time-tracking"
                    width="1100"
                    height="622">
                    <TimeTracking id="modal-window" items={this.projectDescription} />
                </modal>

                <table class="table table-bordered table-sm" style="font-size: 10pt;">
                    <thead >
                        <tr>
                            <th style="background-color: #e4e4e4;" rowspan="4" colspan="1" >Списано часов за день</th>
                            <th style="background-color: #d4d4d4; font-size: 13pt;" colspan={this.container.getDayCount()}>
                                <span class="oi mr-3" data-glyph="chevron-left" onClick={(e) => { this.handleClick(e, 'left') }}  ></span>
                                    {this.container.getMonthTitle()}
                                <span onClick={(e) => { this.handleClick(e, 'right') }} class="oi ml-3" data-glyph="chevron-right"></span></th>
                        </tr>
                        <tr >
                            {/* дни месяца */}
                            {Array.from({ length: this.container.getDayCount() },
                                (v, k) => k + 1).map((index) => (
                                    <th class={this.container.getHolidayCell(index, this.container.getMonth(), this.container.getYear())}>
                                        {index}
                                    </th>
                                ))}
                        </tr>
                        <tr >
                            {/* дни недели */}
                            {Array.from({ length: this.container.getDayCount() },
                                (v, k) => k + 1).map((index) => (
                                    <th class={this.container.getHolidayCell(index, this.container.getMonth(), this.container.getYear())}>
                                        {this.container.getWeekDay(index)}
                                    </th>
                                ))}
                        </tr>
                        <tr >
                            {/* списанные часы */}
                            {Array.from({ length: this.container.getDayCount() },
                                (v, k) => k + 1).map((index) => (
                                    <th class= 
                                        {this.container.getHolidayCell(index, this.container.getMonth(), this.container.getYear())
                                            +" "+
                                        this.container.getTimeColorCell(this.container.getTimeTracking(index))
                                        }
                                       >
                                        {this.container.getTimeTracking(index)}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {/* список проектов */} 
                        {Array.from({ length: this.container.getProject().length },
                            (v, k) => k).map((i) => (
                                <tr class="raw_time_edit">
                                    <td class="text-left"> {this.container.getProject()[i].title}</td>
                                        {Array.from({ length: this.container.getDayCount() },
                                            (v, k) => k + 1).map((index) => (
                                                <td onClick={(e) => 
                                                    { 
                                                        this.handleClickCellModalOpen(
                                                            e, 
                                                            this.container.getProject()[i].id, 
                                                            this.container.getProject()[i].jira_id, 
                                                            this.container.getProject()[i].title, 
                                                            index, 
                                                            this.container.getProject()[i].is_inside
                                                        ); 
                                                        this.handleClickModal(e);  
                                                    }} 
                                                    class={"active-cells " + this.container.getHolidayCell(index, this.container.getMonth(), this.container.getYear())}>
                                                    {this.container.getProjectWriteOff(index, this.container.getProject()[i].id)}
                                                </td>
                                        ))}
                                </tr>
                        ))}
                    </tbody>
                </table>

                <style jsx>{`
                    .current-day{
                        background: #fbd9d9;
                    }
                    .bad-write-off{
                        color: #ff6b6b;
                    }
                    .good-write-off{
                        color: #0e9c1a;
                    }
                    .calendar{
                        font-weight: bold;
                        color: #292b2c;
                        font-family: 'Open Sans';
                        //border: none;
                        //border-bottom:2px solid #292b2c9e;
                        width: 10%;
                    }
                    .exit{
                        font-size: 25pt; 
                        color:#ffffff; 
                        :hover{
                            color: #e4e4e4;
                        }
                    }
                    span:hover{
                            color: #a2a2a2;
                    }
                    {th,td}.holiday-cell{
                        background: #e8f4ff;
                    }
                    input{
                        border: none;
                        border-bottom: 1px solid #000;
                        outline: 0;
                        text-align: right;
                        width: 200px;
                    }
                    td.active-cells:hover{
                        background: #e4e4e4; 
                    }
                    th{
                        background-color: #e8f4ff7d;
                        text-align: center;
                    }
                    td{
                        text-align: center;
                    }
                    .raw_time_edit:hover{
                        background-color: #e4e4e4;
                    }

                    
                `}</style>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/Report/Report.js